import React from 'react'
import { useFieldArray, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Button, Header, Segment, Table } from 'semantic-ui-react'
import AvgCrop from './AvgCrop'

interface Props {
  herdIndex: number
}

const AvgCrops:React.FC<Props> = ({ herdIndex }) => {
  const { t } = useTranslation()
  const { control } = useFormContext()

  const { fields, append, remove } = useFieldArray({
    control,
    name: `herdGroups[${herdIndex}].feeds`,
    keyName: 'key'
  })

  return (
    <>
      <Header attached='top' block>
        {t('Average Crops')}
      </Header>
      <Segment attached style={{ overflow: 'visible' }}>
        <Table celled>
          <colgroup>
            <col style={{ width: '40%' }} />
            <col style={{ width: '40%' }} />
            <col style={{ width: '15%' }} />
          </colgroup>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>{t('Feed component')}</Table.HeaderCell>
              <Table.HeaderCell>{t('Percentage')}</Table.HeaderCell>
              <Table.HeaderCell>{t('Actions')}</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {fields.map((field, feedIndex) => (
              <AvgCrop
                key={field.key}
                id={field.key}
                index={feedIndex}
                removeFeed={remove}
              />
            ))}
          </Table.Body>
        </Table>
        <div style={{ display: 'flex', justifyContent: 'end', marginTop: '1em' }}>
          <Button
            type='button'
            size='small'
            icon='plus'
            style={{ color: 'white' }}
            content={t('Add Feed')}
            onClick={() => append({
              id: null,
              cftFeedRegionId: null,
              dryMatterValue: null,
              freshWeightValue: null
            })}
          />
        </div>
      </Segment>
    </>
  )
}
export default AvgCrops